export default "__VITE_ASSET__BdPnU3Ym__"